import { render, staticRenderFns } from "./addscore.vue?vue&type=template&id=2c997230&scoped=true"
import script from "./addscore.vue?vue&type=script&lang=js"
export * from "./addscore.vue?vue&type=script&lang=js"
import style0 from "./addscore.vue?vue&type=style&index=0&id=2c997230&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c997230",
  null
  
)

export default component.exports